export default "__VITE_ASSET__24f500cd__"